module.exports = __webpack_public_path__ + "static/media/portfolioDesign.268fc279.png";